export default __webpack_public_path__ + "static/media/Typology2.4f63b2f4.png";